import { tv } from 'tailwind-variants'

export const dropdownVariants = tv({
  slots: {
    item: 'first:rounded-t-mili last:rounded-b-mili px-deca border-0 border-t border-solid border-secondary-xlight h-tera text-secondary-medium flex flex-row items-center hover:cursor-pointer hover:text-secondary-xdark hover:bg-secondary-xlight',
    titlePopper: 'font-bold p-deca text-nowrap text-black',
    containerActions: 'flex flex-col',
    containerLabel: 'flex flex-row space-x-mili items-center',
    icon: 'flex text-secondary-light mr-mili text-kilo'
  },
  variants: {
    first: {
      true: {
        item: 'rounded-t-mili'
      }
    },
    last: {
      true: {
        item: 'rounded-b-mili'
      }
    }
  }
})
